import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, null, -1)
const _hoisted_3 = { class: "col-12 d-flex justify-content-between align-items-center mt-3" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = { class: "text-center mb-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_9 = { class: "table table-bordered" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Telefone"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_11 = {
  key: 0,
  class: "fa fa-check text-success"
}
const _hoisted_12 = {
  key: 1,
  class: "fa fa-times text-danger"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "col-12 px-0 py-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-2" }, null, -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "col text-right py-2 d-flex justify-content-end" }

import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import VueTable, { Header } from 'vue3-easy-data-table';
import { DateTime } from 'luxon';
import Transmission from "@/models/Transmission";
import TransmissionService from "@/services/transmission.service";
import StatsCard from './StatsCard.vue';
import whatsappService from '@/services/whatsapp.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const tableHeader: Header[] = [
  { text: 'id', value: 'id' },
  { text: 'Nome', value: 'name' },
  { text: 'Mensagem', value: 'body' },
  { text: 'Arquivo', value: 'file_url' },
  { text: 'data', value: 'creation_date' },
  { text: '-', value: 'actions' },
];

const itens = ref<Transmission[]>([]);
const isLoading = ref(false);
const isQrCodeModalVisible = ref(false);
const qrCode = ref<string | null>(null);
const isLoadingQrCode = ref(false);
const isFetchingQrCode = ref(false);
const phones = ref<{ phone_number: string, status: string }[]>([]);
let pollingInterval: number | null = null;

let cards = ref([
  { title: 'Total de Mensagens', value: 0, iconClass: 'fa-envelope' },
  { title: 'Mensagens de Hoje', value: 0, iconClass: 'fa-calendar-day' },
  { title: 'Transmissões Totais', value: 0, iconClass: 'fa-paper-plane' },
]);

const openQrCodeModal = async () => {
  isQrCodeModalVisible.value = true;
  await fetchPhones(); 
  startPollingPhones();
};

const fetchPhones = async () => {
  try {
    const response = await whatsappService.getPhonesData();
    phones.value = response.data;
  } catch (error) {
    console.error('Erro ao buscar dados dos telefones:', error);
  }
};

const fetchQrCode = async () => {
  if (isFetchingQrCode.value) return;
  isFetchingQrCode.value = true;

  qrCode.value = null; // Reseta o QR Code antes de buscar
  isLoadingQrCode.value = true;

  try {
    const response = await whatsappService.getQrCode();
    qrCode.value = response.data.qrCode;
  } catch (error) {
    console.error('Erro ao buscar QR code:', error);
  } finally {
    isLoadingQrCode.value = false;
  }
};

const startPollingPhones = () => {
  if (pollingInterval) return; 

  pollingInterval = window.setInterval(() => {
    fetchPhones();
  }, 5000); 
};

const stopPollingPhones = () => {
  if (pollingInterval) {
    clearInterval(pollingInterval);
    pollingInterval = null;
  }
};

onMounted(() => {
  isLoading.value = true;
  TransmissionService.getCardData().then((response) => {
    cards.value[0].value = response.data.totalMessages;
    cards.value[1].value = response.data.totalDayMessages;
    cards.value[2].value = response.data.totalTransmissions;
    isLoading.value = false;
  }).catch(error => {
    console.error('Erro ao buscar dados dos cartões:', error);
  });

  TransmissionService.getAll().then((response) => {
    itens.value = response.data;
    isLoading.value = false;
  });
});

onUnmounted(() => {
  stopPollingPhones();
});

const closeQrCodeModal = () => {
  nextTick(() => {
    stopPollingPhones();
    qrCode.value = null;
    phones.value = [];
    isQrCodeModalVisible.value = false;
    isFetchingQrCode.value = false; // Reativa o botão ao fechar a modal
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-success",
          onClick: openQrCodeModal
        }, "Gerenciar Números")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "btn btn-sm btn-success",
            to: { name: 'createTransmission' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Criar Transmissão")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            class: "btn btn-sm btn-success",
            to: { name: 'createShipmentTransmission' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Criar Remessa")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (isQrCodeModalVisible.value)
      ? (_openBlock(), _createBlock(_component_b_modal, {
          key: 0,
          modelValue: isQrCodeModalVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isQrCodeModalVisible).value = $event)),
          title: "Números conectados",
          onHide: closeQrCodeModal,
          "no-fade": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary mb-3",
                onClick: fetchQrCode,
                disabled: isFetchingQrCode.value
              }, " Conectar novo número ", 8, _hoisted_7),
              (phones.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phones.value, (phone, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(phone.phone_number), 1),
                            _createElementVNode("td", null, [
                              (phone.status.toLowerCase() === 'conectado')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                                : (_openBlock(), _createElementBlock("i", _hoisted_12)),
                              _createTextVNode(" " + _toDisplayString(phone.status), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, "Nenhum telefone conectado.")),
              (qrCode.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: qrCode.value,
                    alt: "QR Code",
                    class: "img-fluid"
                  }, null, 8, _hoisted_14))
                : (isLoadingQrCode.value)
                  ? (_openBlock(), _createBlock(_component_b_spinner, {
                      key: 3,
                      label: "Carregando..."
                    }))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (card, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4 mb-4",
            key: index
          }, [
            _createVNode(StatsCard, {
              title: card.title,
              value: card.value,
              iconClass: card.iconClass
            }, null, 8, ["title", "value", "iconClass"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(VueTable), {
            loading: isLoading.value,
            headers: tableHeader,
            items: itens.value
          }, {
            "item-file_url": _withCtx((item) => [
              (!!item.file_url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.file_url,
                    target: "_blank"
                  }, "Abrir", 8, _hoisted_19))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
            ]),
            "item-actions": _withCtx((item) => [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: { name: 'transmission', params: { id: item.id } },
                  class: "btn btn-sm btn-info mr-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Detalhes")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_router_link, {
                  to: { name: 'transmissionClone', params: { cloneId: item.id } },
                  id: "clonar-btn",
                  class: "btn btn-sm btn-success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Clonar")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            "item-creation_date": _withCtx((item) => [
              _createTextVNode(_toDisplayString(_unref(DateTime).fromISO(item.creation_date).toLocaleString()), 1)
            ]),
            _: 1
          }, 8, ["loading", "items"])
        ])
      ])
    ])
  ]))
}
}

})